import { Pipe, PipeTransform } from '@angular/core';
import { Country } from '@zero/onboarding/domain';

@Pipe({
  name: 'countryFilter',
  standalone: true,
})
export class CountryFilterPipe implements PipeTransform {
  public transform(countries: Country[], filter: string): Country[] {
    if (!countries?.length && !filter) {
      return [];
    }

    return countries.filter((country) => country.fullName.toLowerCase().includes(filter.toLowerCase()));
  }
}
